import { FlowSummary } from '@/lib/api/email-flows/types';
import { StanAccordion, StanAccordionBody, StanAccordionHeader, StanAccordionItem } from '@/components';
import { useAccordionController } from '@/hooks/useAccordionController';
import { FlowEmailTimeline } from '../../components';
import { useIsMobile } from '@/hooks/useMediaQuery';

interface EmailNavigationAccordionProps {
    flow: FlowSummary;
    currentEmailId?: number;
}

export const EmailNavigationAccordion = ({ flow, currentEmailId }: EmailNavigationAccordionProps) => {
    const isMobile = useIsMobile();

    const accordionController = useAccordionController({
        allowMultipleOpen: false,
        initialOpenItems: [isMobile ? '' : 'email-navigation'], // Keep accordion open by default
    });

    // Check if flow has new_referral tag
    const tags = flow.data?.specific_time?.tags || [];
    const hasNewReferralTag = tags.some(tag => tag.name === 'new_referral');

    // Calculate current email order
    const currentEmailIndex = flow.flow_emails?.findIndex(e => e.flow_email_id === currentEmailId) ?? -1;
    const currentEmailOrder = currentEmailId ? currentEmailIndex + 1 : (flow.flow_emails?.length || 0) + 1;
    const totalEmails = flow.flow_emails?.length || 0;

    return (
        <div className='w-full md:w-1/3'>
            <StanAccordion controller={accordionController}>
                <StanAccordionItem id='email-navigation' isCard className='bg-bg-canvas shadow-stan'>
                    <StanAccordionHeader>
                        <div className='text-heading-h4 md:text-heading-h3'>
                            Email {currentEmailOrder} of {totalEmails + (currentEmailId ? 0 : 1)}
                        </div>
                    </StanAccordionHeader>

                    <StanAccordionBody>
                        <FlowEmailTimeline
                            flowEmails={flow.flow_emails || []}
                            flowId={flow.flow_id}
                            flowStatus={flow.status}
                            flowTrigger={flow.trigger || flow.trigger_type || 'checkout'}
                            flow={flow}
                            hasNewReferralTag={hasNewReferralTag}
                            compact
                            currentEmailId={currentEmailId}
                        />
                    </StanAccordionBody>
                </StanAccordionItem>
            </StanAccordion>
        </div>
    );
};
